import { ContainerModel } from "models/locker/entities/ContainerModel";

export interface IContainerAllocationModel {
    uuid?: string;
    container: ContainerModel;
    inLocker: boolean;
    isReturn: boolean;
    observations?: string;
    photo?: string;
    failed: boolean;
}


export class ContainerAllocationModel implements IContainerAllocationModel {
    uuid?: string;
    key?: React.Key;
    container: ContainerModel;
    inLocker: boolean;
    isReturn: boolean;
    observations?: string;
    photo?: string;
    failed: boolean;

    constructor(data: IContainerAllocationModel) {
        this.uuid = data?.uuid;
        this.key = data?.uuid;
        this.container = new ContainerModel(data.container);
        this.inLocker = data.inLocker;
        this.isReturn = data.isReturn;
        this.observations = data?.observations;
        this.photo = data?.photo;
        this.failed = data?.failed;
    }
}